// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { useMemo } from 'react';
import { useTraderPortfolioData } from './use-trader-portfolio-data';
import { useMultiAssetBacktest } from '@shared/portfolio-analytics/components/backtest';

export const useTraderBacktest = () => {
  const {
    periodPicker,
    targetHoldings,
    benchmark,
    isLoading: isLoadingPortfolio,
  } = useTraderPortfolioData();

  const backtestPayload = useMemo(
    () => ({
      benchmark,
      hist: periodPicker.period,
      holdings: targetHoldings,
      skip: benchmark.length === 0 || targetHoldings.length === 0,
    }),
    [benchmark, periodPicker.period, targetHoldings],
  );

  const {
    analysis,
    backtest,
    kpis,
    returns,
    isFetchingBacktesting,
    isLoadingBacktesting,
  } = useMultiAssetBacktest(backtestPayload);

  const isLoading = useMemo(() => {
    return [isLoadingPortfolio, isFetchingBacktesting, isLoadingBacktesting].some(
      Boolean,
    );
  }, [isLoadingPortfolio, isFetchingBacktesting, isLoadingBacktesting]);

  return {
    analysis,
    backtest,
    kpis,
    returns,
    periodPicker,
    isLoading,
    backtestPayload,
  };
};
